/*
 * sarwa translations for the "ar" locale.
 *
 * Split out of locales/ar.js so this feature's copy stops shipping to
 * every route in the app. See locales/sarwa/index.js.
 */
export default {
  sarwa: {
    sarwa_life_individual: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/life-logo-ar.svg",
      title: "ثروة لتأمينات الحياة",
      hyperlink: "موقع ثروة لتأمينات الحياة",
      paragraph:
        "ثروة حياة هي إحدى شركات التأمين الرائدة في مصر تهدف خِطَط التأمين لدينا إلى حماية جودة حياتك من خلال خطط تأمين متنوعة، منها التأمين الطبي وتأمين المدخرات وخطط استثمار التقاعد والحماية الفردية والجماعية. نقدم لك مجموعة متنوعة وشاملة من الاختيارات مع خدمة مميزة  توازن بين المرونة والاستجابة السريعة مع تبني المعايير الدولية في الإجراءات التأمينية، يمكننا تقديم أفضل تجربة لعملائنا وتقديم خدمات شاملة ومبتكرة.",
      list_title: "تأمينات الأفراد",
      list: [
        {
          title: "الحياة ثروة (تأمين مؤقت محدد المدة).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "ثروة أمان (تجديد تلقائي بدون دراسة).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "ثروة لايف (ادخار).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "الحماية ضد أخطار السرطان للرجال.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "الحماية ضد أخطار السرطان للإناث.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "الحماية ضد أخطار التدخين.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-Life?lang=ar",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaLife.webp",
    },
    sarwa_life_companies: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/life-logo-ar.svg",
      title: "ثروة لتأمينات الحياة",
      sub_title: "ثروة حياة، الحياة ثروة",
      hyperlink: "موقع ثروة لتأمينات الحياة",
      paragraph:
        "ثروة لتأمينات الحياه هي شركة رائدة في مجال التأمين في مصر. نمكن الأفراد والمؤسسات من الحصول على خدمات تأمين طبي متميزة بالإضافة إلى خدمات أخرى من خلال مجموعة متنوعة من حلول التأمين على الحياة والاستثمار المبتكرة والشاملة. نقدم خيارات متنوعة لحماية صحة ورفاهية الأفراد والمجموعات في الشركات بمختلف طبيعتها وحجمها في مختلف القطاعات. خدماتنا تشمل خطط التأمين الطبي الفردي والجماعي، خطط التأمين على الحياة، خطط الاستثمار، خطط التقاعد، و خطط الحماية والادخار. نعمل كل يوم على تقديم أفضل خدمات التأمين للشركات في مصر. بصفتنا شريكًا لك، نقدم خيارات متنوعة لحماية صحة ورفاهية الأفراد والمجموعات في شركتك. نحقق ذلك من خلال إدارة استثمارات احترافية توفر لك ولأفراد شركتك منتجات مختلفة وفرص لا حصر لها للاستفادة منها يوميًا.",
      list_title: "تأمينات الشركات",
      list: [
        {
          title: "وثيقة تأمين جماعي – حماية",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي – ائتمان",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي - استثمار",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي - حوادث شخصية",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين طبي جماعي",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "(SME’S) الشركات المتوسطة والصغيرة",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي - حوادث شخصية اختياري",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaLife.webp",
    },
    sarwa_insurance_individual: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-logo-ar.svg",
      title: "ثروة للتأمين",
      sub_title: "هنغير فكرتك عن الـتأمين",
      hyperlink: "موقع ثروة للتأمين",
      paragraph:
        "في ثروة هنغير فكرتك عن التأمين عن طريق بناء الثقة والشفافية في جميع أعمالنا والتي تمتد من تأمينات الأفراد الى تأمين الشركات. نسعى دائماً لتقديم خدمة متميزة ومتطورة تناسب احتياجات كل عميل حيث يقوم فريقنا من الخبراء بمساعدتك على فهم احتياجاتك التأمينية وإيجاد التغطية المناسبة لك مدعوماً بأحدث التكنولوجيا الرقمية لتصميم خطة تلبي احتياجاتك وتقديم الدعم وقتما تحتاج إليه. تؤمن ثروة للتأمين أن أصولك هي أهم ما لديك، ونحن هنا لمساعدتك على حمايتها من أي أحداث غير متوقعة مع تقديم عملية تأمين سريعة.",
      list_title: "تأمينات الأفراد",
      list: [
        {
          title: "تأمين السيارات.",
          link: "https://sarwa.insurance/sarwa-insurance/product/motorInsurance/?lang=ar",
        },
        {
          title: "تأمين المنزل.",
          link: "https://sarwa.insurance/sarwa-insurance/product/homeInsurance/?lang=ar",
        },
        {
          title: "تأمين الحوادث الشخصية ونمط الحياة.",
          link: "https://sarwa.insurance/sarwa-insurance/product/personalAccidents/?lang=ar",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-insurance/product/retail/?lang=ar",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaInsurance.webp",
    },
    sarwa_insurance_companies: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-logo-ar.svg",
      title: "ثروة للتأمين",
      sub_title: "نغير فكرتك عن الـتأمين",
      hyperlink: "موقع ثروة للتأمين",
      paragraph:
        "ثروة للتأمين، إحدى شركات التأمين الرائدة في مصر، تتطلع لتغيير النظرة المجتمعية تجاه التأمين من خلال تعزيز الثقة والالتزام بالشفافية في جميع خدماتنا التي تشمل خطط التأمين الفردية، وتأمين الشركات الصغيرة والمتوسطة والشركات متناهية الصغر، بالإضافة إلى حلول التأمين المؤسسي والتجاري في مصر.يحرص فريقنا من الخبراء على فهم احتياجاتك الفريدة وصياغة خطط تأمين مصممة خصيصًا لحماية أصولك وأعمالك وممتلكاتك بشكل فعال. نهتم ببناء علاقات دائمة مع شركائنا، ونضمن  تجربة تأمين سلسة تلبي كافة احتياجاتك من البداية إلى النهاية.",
      list_title: "تأمينات الشركات",
      list: [
        {
          title: "تأمين الممتلكات",
          link: "https://sarwa.insurance/sarwa-insurance/product/propertyInsurance/?lang=ar",
        },
        {
          title: "التأمينات الهندسية",
          link: "https://sarwa.insurance/sarwa-insurance/product/engineeringInsurance/?lang=ar",
        },
        {
          title: "تأمين أساطيل السيارات",
          link: "https://sarwa.insurance/sarwa-insurance/product/motorFleetInsurance/?lang=ar",
        },
        {
          title: "التأمين البحري والبري بضائع",
          link: "https://sarwa.insurance/sarwa-insurance/product/marineInsurance/?lang=ar",
        },
        {
          title: "تأمين المسؤوليات والتأمينات المالية",
          link: "https://sarwa.insurance/sarwa-insurance/product/publicLiabilityInsurance/?lang=ar",
        },
        {
          title: "تأمين طبي",
          link: "https://sarwa.insurance/sarwa-insurance/product/medicalInsurance/?lang=ar",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-insurance/product/retail/?lang=ar",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaInsurance.webp",
    },
  },
  sarwa_capital: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brand-sarwa.webp",
  sarwa_capital2: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-2.webp",
  sc_title1: "ثروة كابيتال",
  sc_title2: "المعاملات الهامة التي نفخر بها:",
  sc_subtitle2: "روادإدارة أدوات الدين بسجل حافل من المعاملات في ظل تحديات السوق المختلفة لتحقيق السيولة المالية.",
  sc_body1: `لطالما كان الاستثمار في أسواق رأس مال الدين (DCM) محورا مركزيا لنموذج أعمال ثروة حيث سمح لنا بتنوع قاعدة تمويلنا وإعادة هيكلة عملياتنا بنجاح.  ومن خلال خبراتنا من هذه التجربة العميقة الجذور في مجال ادارة أسواق الدين ، قمنا بتسويق مجموعة من خدمات التمويل التي دفعتنا إلى أن نصبح أكبر لاعب في مصر في هذا القطاع. وقد قامت ثروة بترتيب وإصدار أكثر من 26 مليار جنيه من إصدارات الديون منذ عام  2005، بما في ذلك أول طرح من نوعه لسندات التوريق في السوق المصري. كما أن ثروة هي أول مصدر للصكوك المرخصة في السوق المصرية.

يتمتع فريقنا بسجل حافل في هيكلة وتسعير وإصدار التعاملات المالية  في ظل تقلبات وظروف السوق الصعبة، بما في ذلك الإصدارات التي تحمل تصنيف AA+ – وهو أعلى تصنيف للكيان غير السيادي في مصر.

ولذلك فإننا نفخر بخبرة طويلة في هذه القطاع وشبكة من العلاقات مع المستثمرين غير المصرفيين والخبراء وهيئات التصنيف وغيرها من المؤسسات المالية. كما نعمل بوتيرة ثابتة مع هيئات التصنيف والبنوك الرائدة من خلال منحها إمكانية الوصول اليومي والاطلاع على عملياتنا وقاعدة بياناتنا وهو امر نفخر به ويدعم الإصدارات التي نطرحها بمزيد من الثقة والشفافية .

بالإضافة الى الخبرة في مجموعة واسعة من فئات الأصول التي تتراوح بين قروض السيارات والمستحقات العقارية فإننا نعمل ايضاً بنشاط على توسيع خبرتنا لزيادة هياكل التمويل الجديدة والمبتكرة.`,
  sc_body2: [
    "أول طرح للسندات بالسوق المصري في عام 2005",
    "أول طرح للسندات بالدعم العقاري في عام 2015.",
    "أول طرح صكوك مضاربة لمؤسسة مالية في 2020",
  ],
};
